const styles = theme => ({
  dialog: {
    maxWidth: 600
  },
  checkCircle: {
    color: '#00e56f'
  }
})

export default styles;